import React from "react";
import Icon from "../../components/Icon/Icon";

import "./EmptyEarnings.scss";

function EmptyEarnings() {
    return (
        <div className="container">
            <Icon alias="start_earning" color="#ff0000" width={200} />
            <h3 className="title">Start Earning Today</h3>
            <p className="description">Ready to earn from your creations? <br />
                Publish something amazing now.</p>
        </div>
    );
}

export default EmptyEarnings;
